import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgDeanonim = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 23" {...props}>
    <g fill="none" fillRule="evenodd">
      <path
        stroke="#17181A"
        d="M10.207 1.136c.808-.06 1.316-.098 1.524-.112 1.149-.087 2.024.566 2.628 1.958.904 2.089 2.273 7.966.396 16.076-.297 1.902-1.459 2.746-2.527 2.618a88.727 88.727 0 0 0-2.068-.226c-.834-.163-1.175-.763-1.023-1.8.227-1.555.176-1.037.386-2.284.21-1.247.32-1.13 1.68-1.739 1.36-.61 1.717-.282 1.728-2.177.007-1.264-.037-2.934-.132-5.01.01-.736-.441-1.172-1.355-1.31-1.37-.205-1.682-.507-2.013-1.944a23.43 23.43 0 0 1-.474-2.756c.026-.803.442-1.234 1.25-1.294z"
      />
      <path
        d="m23.621.672.707.707-4.95 4.95-.706-.708zM19 10h6v1h-6zM2.595 1.553l-.643.766 21.45 17.998.642-.766zM1.379 20.328l-.707-.707 4.95-4.95.706.708zM6 10H0v1h6z"
        fill="#17181A"
      />
    </g>
  </svg>
);
const Memo = memo(SvgDeanonim);
export default Memo;
